module.exports = __webpack_public_path__ + "files/3f4f4d9c1ed6fa05dd9099315af4c9db.png";